module.exports = __webpack_public_path__ + "img/drag-handle.34bd9d04.svg";